export default function Tasting() {
  const whatsappUrl = "https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20proposta%20para%20meu%20evento!";

  return (
    <section id="proposta" className="relative min-h-[500px] flex items-center justify-center overflow-hidden py-16 md:py-24" style={{ background: 'linear-gradient(135deg, #0D0A06 0%, #1A1200 50%, #0D0A06 100%)' }}>
      <div className="relative z-10 w-full max-w-2xl px-4 md:px-8 text-center">
        <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-6 md:mb-8">
          <i className="ri-quill-pen-line text-[#D4AF37] text-4xl md:text-5xl"></i>
        </div>

        <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-light text-white mb-4 tracking-wide">
          Solicitar Minha Proposta
        </h2>
        <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-6"></div>
        <p className="text-gray-300 font-light text-sm md:text-base mb-10 md:mb-14 leading-relaxed px-4 md:px-0">
          Fale diretamente com nossa equipe pelo WhatsApp e receba uma proposta personalizada para o seu evento.
        </p>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-3 px-10 py-4 bg-[#D4AF37] text-black text-xs uppercase tracking-widest font-normal font-['Montserrat'] transition-all duration-300 hover:bg-[#c9a42e] hover:scale-[1.02] cursor-pointer whitespace-nowrap"
        >
          <i className="ri-whatsapp-line text-lg"></i>
          Solicitar Minha Proposta
        </a>
      </div>
    </section>
  );
}
